const translations = {
  "en": {
    "Submission successful!": "Submission successful!"
  },
  "zh-tw": {
    "Submission successful!": "提交成功！"
  }
};

export default translations;
